// extracted by mini-css-extract-plugin
export var bodyRow = "_fk-d";
export var cardColumns = "_fk-e";
export var ellipsesOverflow = "_fk-2";
export var flatBottomCorners = "_fk-3";
export var flatTopCorners = "_fk-4";
export var headerActionsDropdown = "_fk-f";
export var headerBottomRow = "_fk-c";
export var headerTopRow = "_fk-b";
export var orderDetailsWrapper = "_fk-0";
export var orderInfoContainer = "_fk-1";
export var productDetails = "_fk-9";
export var productImage = "_fk-5";
export var responsiveTable = "_fk-8";
export var shipmentContainer = "_fk-a";
export var tableBottomLeft = "_fk-6";
export var tableBottomRight = "_fk-7";